export default __webpack_public_path__ + "static/media/GoldFeature2.69ed9004.svg";